import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SitesList from './SitesList';
import SiteCreate from './SiteCreate';
import SiteView from './SiteView';
import SiteEdit from './SiteEdit';

function Sites() {
  return (
    <Routes>
      <Route path="" element={<SitesList />} />
      <Route path="create" element={<SiteCreate />} />
      <Route path="edit/:siteId" element={<SiteEdit />} />
      <Route path=":siteId" element={<SiteView />} />
    </Routes>
  );
}

export default Sites; 